<!-- 系统详情页面 -->
<template>
  <div class="systemDetail section-main__warp">
    <div class="sysForm">
      <ioc-form
        :option="addVcnOption"
        v-model="sysDetData"
        @submit="submit"
        @reset-change="cancelBtn"
      ></ioc-form>
    </div>
  </div>
</template>
<script>
import { api } from "../../api";
import { Cache, Crypto } from "$utils";
export default {
  data() {
    // 校验系统名称--不能包含空格
    const checkSysName = (rule, value, callback) => {
      if (/\s/.test(value)) {
        callback(new Error(this.$t("deviceAccess.message.nospace")));
      } else {
        callback();
      }
    };
    // 校验IP
    const checkIp = (rule, value, callback) => {
      if (
        /^(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|[1-9])\.(00?\d|1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)\.(00?\d|1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)\.(00?\d|1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)$/.test(
          value
        )
      ) {
        callback();
      } else {
        callback(new Error(this.$t("deviceAccess.message.ipformat")));
      }
    };
    return {
      systemId: "",
      sysDetData: {},
      addVcnOption: {
        menuPostion: "left",
        column: [
          {
            label: this.$t("deviceAccess.label.plugins"),
            prop: "pluginName",
            labelWidth: "110",
            readonly: true
          },
          {
            label: this.$t("deviceAccess.label.factory"),
            prop: "factoryName",
            labelWidth: "110",
            readonly: true
          },
          {
            label: this.$t("deviceAccess.label.platname"),
            prop: "platName",
            labelWidth: "110",
            readonly: true
          },
          {
            label: this.$t("deviceAccess.label.version"),
            prop: "platVersion",
            labelWidth: "110",
            readonly: true
          },
          {
            label: this.$t("deviceAccess.label.os"),
            prop: "osType",
            labelWidth: "110",
            readonly: true
          },
          {
            label: this.$t("deviceAccess.label.protocol"),
            prop: "protocolType",
            labelWidth: "110",
            readonly: true
          },
          {
            label: this.$t("deviceAccess.label.connection"),
            prop: "connectionMode",
            labelWidth: "110",
            type: "radio",
            border: true,
            dicData: [
              {
                label: this.$t("deviceAccess.label.platform"),
                value: "1"
              }
            ],
            span: 12,
            clearable: true,
            row: true,
            required: []
          },
          {
            label: this.$t("deviceAccess.label.systemname"),
            prop: "systemName",
            labelWidth: "110",
            clearable: true,
            rules: [
              {
                required: true,
                message: this.$t("deviceAccess.message.systemname"),
                trigger: "blur"
              },
              { validator: checkSysName, trigger: "blur" },
              {
                min: 1,
                max: 50,
                message: this.$t("deviceAccess.message.less50"),
                trigger: "blur"
              }
            ]
          },
          {
            label: this.$t("deviceAccess.label.controlcenter"),
            prop: "areaName",
            labelWidth: "110",
            type: "select",
            clearable: true,
            change: (val) => {
              val.column.dicData.map((item) => {
                if (item.value == val.value) {
                  this.sysDetData.areaCode = item.table;
                }
              });
            },
            dicData: []
          },
          {
            label: this.$t("deviceAccess.label.ip"),
            prop: "serverIp",
            labelWidth: "110",
            clearable: true,
            rules: [
              {
                required: true,
                message: this.$t("deviceAccess.message.ip"),
                trigger: "blur"
              },
              { validator: checkIp, trigger: "blur" }
            ]
          },
          {
            label: this.$t("deviceAccess.label.domain"),
            prop: "domainCode",
            labelWidth: "110",
            readonly: false,
            clearable: true,
            rules: [
              {
                required: true,
                message: this.$t("deviceAccess.message.domain"),
                trigger: "blur"
              },
              {
                min: 1,
                max: 200,
                message: this.$t("deviceAccess.message.less200"),
                trigger: "blur"
              }
            ]
          },
          {
            label: this.$t("deviceAccess.label.port"),
            prop: "serverPort",
            labelWidth: "110",
            clearable: true,
            rules: [
              {
                required: true,
                message: this.$t("deviceAccess.message.port"),
                trigger: "blur"
              },
              {
                pattern:
                  /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])$/,
                message: this.$t("deviceAccess.message.port2"),
                trigger: "blur"
              }
            ]
          },
          {
            label: this.$t("deviceAccess.label.account"),
            prop: "serviceUsername",
            labelWidth: "110",
            clearable: true,
            rules: [
              {
                required: true,
                message: this.$t("deviceAccess.message.account"),
                trigger: "blur"
              }
            ]
          },
          {
            label: this.$t("deviceAccess.label.password"),
            prop: "servicePassword",
            labelWidth: "110",
            type: "password",
            clearable: true,
            rules: [
              {
                required: true,
                message: this.$t("deviceAccess.message.password"),
                trigger: "blur"
              }
            ]
          }
        ],
        submitText: this.$t("deviceAccess.button.save"),
        emptyText: this.$t("deviceAccess.button.cancel"),
        submitIcon: "false",
        emptyIcon: "false"
      }
    };
  },
  created() {
    this.systemId = this.$route.query.systemId;
    this.deviceType = this.$route.query.deviceType;
    this.getSelectArea();
  },
  methods: {
    // 查看系统详情时查询控制中心
    getSelectArea() {
      this.$fetch(api.device.selectAreaInfoList, {}).then((res) => {
        this.sysDetail();
        const Array = [];
        res.returnObj.map((item) => {
          const data = {};
          data.table = item.areaCode;
          data.value = item.areaName;
          Array.push(data);
        });
        this.addVcnOption.column[8].dicData = Array;
      });
    },
    // 查询系统详情数据
    sysDetail() {
      const params = {
        systemId: this.systemId
      };
      this.$fetch(api.device.selectSystemInfo, params).then((res) => {
        // let key = Cache.get("OCX_OPTIONS").key
        this.$set(this.sysDetData, "factoryName", res.returnObj.factoryName);
        this.$set(
          this.sysDetData,
          "serverIp",
          res.returnObj.systemExtendInfoMap.serverIp
        );
        this.$set(
          this.sysDetData,
          "connectionMode",
          res.returnObj.connectionMode
        );
        this.$set(this.sysDetData, "platId", res.returnObj.platId);
        this.$set(this.sysDetData, "platName", res.returnObj.platName);
        this.$set(this.sysDetData, "platVersion", res.returnObj.platVersion);
        this.$set(this.sysDetData, "pluginName", res.returnObj.pluginName);
        this.$set(
          this.sysDetData,
          "serverPort",
          res.returnObj.systemExtendInfoMap.serverPort
        );
        this.$set(this.sysDetData, "systemName", res.returnObj.systemName);
        this.$set(this.sysDetData, "systemId", res.returnObj.systemId);
        this.$set(
          this.sysDetData,
          "domainCode",
          res.returnObj.systemExtendInfoMap.domaincode
        );
        this.$set(
          this.sysDetData,
          "serviceUsername",
          res.returnObj.systemExtendInfoMap.userName
        );
        this.$set(
          this.sysDetData,
          "servicePassword",
          res.returnObj.systemExtendInfoMap.password
        );
        // this.$set(this.sysDetData,'servicePassword',Crypto.getDAesString(res.returnObj.systemExtendInfoMap.password,key))
        this.addVcnOption.column[8].dicData.map((item) => {
          console.log(item);
          if (res.returnObj.systemExtendInfoMap.areaCode == item.table) {
            this.$set(this.sysDetData, "areaName", item.value);
          }
        });
        console.log("res.returnObj.osType", res.returnObj.osType == 1);
        if (res.returnObj.osType == 1) {
          this.$set(this.sysDetData, "osType", "Linux");
        } else if (res.returnObj.osType == 2) {
          this.$set(this.sysDetData, "osType", "Windows");
        }
        if (res.returnObj.protocolType == 1) {
          this.$set(this.sysDetData, "protocolType", "http");
        } else if (res.returnObj.protocolType == 2) {
          this.$set(this.sysDetData, "protocolType", "https");
        } else if (res.returnObj.protocolType == 3) {
          this.$set(this.sysDetData, "protocolType", "TCP/IP");
        } else if (res.returnObj.protocolType == 4) {
          this.$set(this.sysDetData, "protocolType", "SDK");
        } else if (res.returnObj.protocolType == 5) {
          this.$set(this.sysDetData, "protocolType", "UDP");
        }
      });
    },

    // 查看详情，提交数据
    submit(val) {
      val.parkId = "1";
      val.deviceGroupCode = "0";
      let key = Cache.get("OCX_OPTIONS").key;
      const params = val;
      params.deviceType = this.deviceType;
      params.servicePassword = Crypto.getAesString(params.servicePassword, key);
      if (params.areaName == "") {
        params.areaCode = "";
      }
      if (params.vcmId == "") {
        params.vcmSiId = "";
      }
      console.log(params);
      this.$fetch(api.device.updateSystemInfo, params)
        .then((res) => {
          if (res.success === true) {
            this.$message.success(res.msgContent);
            this.$router.back(-1);
          } else if (res.success === false) {
            this.$message.error(res.msgContent);
          }
        })
        .catch(() => {});
    },

    // 取消按钮
    cancelBtn() {
      this.$router.back(-1);
    }
  }
};
</script>
<style scoped>
.systemDetail {
  width: 100%;
  height: 100%;
  padding: 50px 0 0 50px;
}
.sysForm {
  float: left;
  width: 70%;
}
:deep .el-input--mini .el-input__inner {
  color: #e1e1e1;
}
</style>
